import { render } from "./BoxHistoricShow.vue?vue&type=template&id=45eab968&scoped=true"
import script from "./BoxHistoricShow.vue?vue&type=script&lang=js"
export * from "./BoxHistoricShow.vue?vue&type=script&lang=js"

import "./BoxHistoricShow.vue?vue&type=style&index=0&id=45eab968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eab968"]])

export default __exports__